import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getQuotationNumberAsync, getWorkOrdersListWithClientAsync } from '@application/features/quotations/quotationThunk';
import { IonIcon } from '@ionic/react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { calendarOutline, informationCircleOutline, close } from 'ionicons/icons';
import moment from 'moment';
import { formatDMY } from '@infrastructure/helpers';
import { Link, useParams } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '@ui/styles/select-style';
import InfoToolTip from './InfoToolTip';
import ToolTip from '@ui/components/VnToolTip';
import '../../style.css';
import { setWorkOrderNumber } from '@application/features/quotations/quotationSlice';
import Select from 'react-select';
import VnNotificationModel from '@ui/components/VnNotificationModel';
const AddQuotationFormInTab = ({ formData, errors, onFieldChange, onCalendarChange, onFieldChangeWithoutWrapper }) => {
    const [selectedWorkOrderValue, setSelectedWorkOrderValue] = useState(null);
    const [deliveryDateSentPickerOpen, setDeliveryDateSentIsOpen] = useState(false);
    const [desiredDeliveryDate, setDesiredDeliveryDate] = useState();
    const [quotationNumberPre, setQuotationNumberPre] = useState('');
    const [quotationNumberPost, setQuotationNumberPost] = useState('');
    const [workOrderList, setWorkOrderList] = useState([]);
    const [isToolTipVisible, setToolTipVisibility] = useState(false);
    const [deliveryDate, setDeliveryDate] = useState();
    const [deliveryDatePickerOpen, setDeliveryDateIsOpen] = useState(false);
    const [isQuotationWarningMessagePopupOpen, setIsQuotationWarningMessagePopupOpen] = useState(false);
    const [quotationForSelectedWorkOrder, setQuotationForSelectedWorkOrder] = useState(null);
    const { WorkOrderListWithClient, QuotationsRequest, WorkOrderListWithClientOptions, UpdateQuotation, WorkOrderNumber, ShippingMethods } = useAppSelector((state) => state.quotation);
    const dispatch = useAppDispatch();
    useEffect(() => {
        return () => {
            dispatch(setWorkOrderNumber(undefined)); // Dispatch the action to clear workOrderNumber
        };
    }, [dispatch]);
    useEffect(() => {
        if (formData.workorderNumber) {
            dispatch(getWorkOrdersListWithClientAsync(formData.workorderNumber ?? ''));
        }
    }, [formData.workorderNumber]);
    useEffect(() => {
        if (WorkOrderNumber) {
            setSelectedWorkOrderValue(WorkOrderNumber.value);
            formData.workOrderId = WorkOrderNumber.value;
            formData.workorderNumber = WorkOrderNumber.label;
            dispatch(getWorkOrdersListWithClientAsync(WorkOrderNumber.label ?? ''));
        }
    }, [WorkOrderNumber]);
    useEffect(() => {
        mappingFieldsBasedOnWorkOrder();
    }, [WorkOrderListWithClient]);
    useEffect(() => {
        if (formData.dateSent) {
            setDesiredDeliveryDate(moment(formData.dateSent).toDate());
        }
        else {
            setDesiredDeliveryDate(null); // Ensure it's set to null when no date is selected
        }
        if (formData.deliveryDate) {
            setDeliveryDate(moment(formData.deliveryDate).toDate());
        }
        else {
            setDeliveryDate(null); // Avoid setting the current date
        }
        mappingFieldsBasedOnWorkOrder();
        setQuotationNumberPost('');
    }, [dispatch, selectedWorkOrderValue]);
    useEffect(() => {
        onFieldChange('quotationNumber', `${quotationNumberPre}@@${quotationNumberPost}`);
        if (quotationNumberPost == '') {
        }
    }, [quotationNumberPost, quotationNumberPre]);
    useEffect(() => {
        if (WorkOrderListWithClientOptions) {
            setWorkOrderList(WorkOrderListWithClientOptions);
        }
    }, [WorkOrderListWithClientOptions]);
    const handleMouseHover = () => {
        setToolTipVisibility(true);
    };
    const handleMouseLeave = () => {
        setToolTipVisibility(false);
    };
    function workOrderAsyncList(inputValue) {
        if (inputValue.length > 2) {
            return dispatch(getWorkOrdersListWithClientAsync(inputValue))
                .unwrap()
                .then((res) => {
                const options = res.map((workOrder) => ({
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                }));
                return options;
            });
        }
        return Promise.resolve([]);
    }
    function mappingFieldsBasedOnWorkOrder() {
        if (selectedWorkOrderValue) {
            const selectedValues = WorkOrderListWithClient?.find((order) => {
                return order.id == selectedWorkOrderValue;
            });
            if (selectedValues) {
                onFieldChange('debtorId', selectedValues.debtorId.toString());
                onFieldChange('debtorName', selectedValues.debtorName);
                setQuotationNumberPre(`O${selectedValues.workOrderNumber}`);
            }
        }
    }
    const handleWorkOrderFieldChange = (workOrderId) => {
        const selectedWorkOrder = WorkOrderListWithClient?.find(order => order.id === workOrderId);
        if (selectedWorkOrder && selectedWorkOrder?.workOrderExistingQuotations && selectedWorkOrder?.workOrderExistingQuotations?.length > 0) {
            setIsQuotationWarningMessagePopupOpen(true);
            setQuotationForSelectedWorkOrder(selectedWorkOrder.workOrderExistingQuotations);
        }
        else {
            setIsQuotationWarningMessagePopupOpen(false);
            setQuotationForSelectedWorkOrder([]);
        }
    };
    useEffect(() => {
        const parts = UpdateQuotation?.quotationNumber.split('@@');
        setQuotationNumberPre(parts ? parts[0] : '');
        setQuotationNumberPost(parts && parts?.length > 1 ? parts[1] : '');
        setDesiredDeliveryDate(UpdateQuotation?.dateSent != null ? moment(UpdateQuotation?.dateSent).toDate() : null);
        setDeliveryDate(UpdateQuotation?.deliveryDate != null ? moment(UpdateQuotation?.deliveryDate).toDate() : null);
        onCalendarChange('dateSent', UpdateQuotation?.dateSent ? moment(UpdateQuotation?.dateSent).format('YYYY-MM-DD') : null);
        onCalendarChange('deliveryDate', UpdateQuotation?.deliveryDate ? moment(UpdateQuotation?.deliveryDate).format('YYYY-MM-DD') : null);
    }, [UpdateQuotation]);
    const openDateSentDatePicker = () => {
        setDeliveryDateSentIsOpen(!deliveryDateSentPickerOpen);
    };
    const openDeliveryDatePicker = () => {
        if (desiredDeliveryDate) {
            setDeliveryDateIsOpen(!deliveryDatePickerOpen);
        }
    };
    function onDesiredDeliveryDateChange(date) {
        setDesiredDeliveryDate(date !== null ? moment(date).toDate() : null);
        if (date) {
            onCalendarChange('dateSent', moment(date).format('YYYY-MM-DD'));
        }
        setDeliveryDate(null);
        onCalendarChange('deliveryDate', null);
        setDeliveryDateSentIsOpen(false);
    }
    function onDeliveryDateChange(date) {
        setDeliveryDate(date !== null ? moment(date).toDate() : null);
        if (date) {
            onCalendarChange('deliveryDate', moment(date).format('YYYY-MM-DD'));
        }
        setDeliveryDateIsOpen(false);
    }
    const { id } = useParams();
    useEffect(() => {
        if (!id) {
            setQuotationNumberPre('');
            setQuotationNumberPost('');
            setDesiredDeliveryDate(null);
            setDeliveryDate(null);
            onCalendarChange('dateSent', null);
            onCalendarChange('deliveryDate', null);
        }
    }, []);
    useEffect(() => {
        if (!id) {
            dispatch(getQuotationNumberAsync(formData.workOrderId))
                .unwrap()
                .then((res) => {
                setQuotationNumberPost(res);
            });
        }
    }, [quotationNumberPre]);
    const clearDateSentHandleClick = () => {
        setDesiredDeliveryDate(null);
        onCalendarChange('dateSent', null);
        setDeliveryDate(null);
        onCalendarChange('deliveryDate', null);
    };
    const clearDeliveryDateHandleClick = () => {
        setDeliveryDate(null);
        onCalendarChange('deliveryDate', null);
    };
    const onConfirmQuotationWarningNotification = () => {
        setIsQuotationWarningMessagePopupOpen(false);
    };
    const onCancelQuotationWarningNotification = () => {
        setIsQuotationWarningMessagePopupOpen(false);
        setQuotationForSelectedWorkOrder(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'container', children: _jsxs("div", { className: 'row', children: [_jsx("div", { className: 'col-sm-9', children: _jsxs("div", { className: 'Vn-form-FormMain', children: [_jsxs("div", { className: 'row', children: [_jsx("div", { children: _jsxs(Form.Group, { controlId: 'quotationNumber', children: [_jsxs(Form.Label, { className: 'vn-text-label', children: ["Offertenummer", _jsx("span", { className: 'vn-AsterikMark', children: "*" })] }), _jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-sm-3', children: [_jsx("input", { id: 'quotationNumberPre', type: 'text', value: quotationNumberPre, readOnly: true, className: 'form-control vn-Input' }), _jsx("div", { className: 'validation-error', children: errors.quotationNumber })] }), _jsx("div", { className: 'col-sm-3', children: _jsx(Form.Control, { type: 'text', name: 'quotationNumber', className: 'vn-Input', value: quotationNumberPost, onChange: (e) => {
                                                                            e.target.value.length <= 4 ? setQuotationNumberPost(e.target.value) : false;
                                                                        }, isInvalid: !!errors.quotationNumber }) })] })] }) }), _jsx("div", { className: 'col-sm-3 mt-3' })] }), _jsxs("div", { className: 'row mt-3', children: [_jsx("div", { className: 'col-sm-6', children: _jsxs(Form.Group, { controlId: 'workOrderId', children: [formData.workOrderId ? (_jsxs(Link, { className: 'vn-anchor-style', target: '_blank', to: `/admin/WorkordersTabs/${formData.workOrderId}`, children: ["Werkorder", _jsx("span", { children: "*" })] })) : (_jsxs(Link, { className: 'vn-anchor-style', to: '', children: ["Werkorder", _jsx("span", { children: "*" })] })), _jsxs("div", { className: 'mt-8', children: [_jsx(AsyncSelect, { name: 'workOrderId', styles: selectStyles, value: WorkOrderListWithClientOptions?.find((c) => c.value == formData.workOrderId), onChange: (selectedOption) => {
                                                                        onFieldChangeWithoutWrapper('workOrderId', selectedOption?.value ? selectedOption?.value.toString() : '');
                                                                        setSelectedWorkOrderValue(selectedOption?.value ? selectedOption?.value.toString() : '');
                                                                        handleWorkOrderFieldChange(selectedOption?.value);
                                                                    }, className: errors.workOrderId
                                                                        ? 'is-invalid async-Select-border-remove'
                                                                        : 'async-Select-border-remove', loadOptions: workOrderAsyncList, placeholder: 'Selecteer...' }), errors.workOrderId && _jsx("div", { className: 'invalid-feedback', children: errors.workOrderId })] })] }) }), _jsx("div", { className: 'col-sm-6', children: _jsxs(Form.Group, { controlId: 'debtorId', children: [formData.debtorId ? (_jsxs(Link, { className: 'vn-anchor-style', target: '_blank', to: `/admin/DebtorTabs/${formData.debtorId}`, children: ["Klant", _jsx("span", { children: "*" })] })) : (_jsxs(Link, { className: 'vn-anchor-style', to: '', children: ["Klant", _jsx("span", { children: "*" })] })), _jsxs("div", { className: 'mt-8', children: [_jsx(Form.Control, { type: 'text', name: 'debtorName', value: formData.debtorName, className: 'vn-Input', onChange: (e) => onFieldChange('debtorName', e.target.value), isInvalid: !!errors.debtorName, readOnly: true }), _jsx(Form.Control.Feedback, { type: 'invalid', children: errors.debtorName })] })] }) })] }), _jsx("div", { className: 'row mt-3', children: _jsx("div", { className: 'col-sm-12', children: _jsxs(Form.Group, { children: [_jsx(Form.Label, { className: 'vn-text-label', children: "Verzendmethode" }), _jsx("div", { children: _jsx(Select, { placeholder: 'Selecteer Klant', isSearchable: true, styles: selectStyles, value: ShippingMethods?.find((option) => option.value === formData.shippingMethodId), options: ShippingMethods, onChange: (selectedOption) => onFieldChange('shippingMethodId', selectedOption.value) }) })] }) }) }), _jsxs("div", { className: 'row mt-3', children: [_jsx("div", { className: 'col-sm-6', children: _jsxs(Form.Group, { children: [_jsx(Form.Label, { className: 'vn-text-label', children: "Datum Verzonden" }), _jsxs("div", { className: 'input-group', children: [_jsx(DatePicker, { selected: desiredDeliveryDate, placeholderText: 'Selecteer datum', onInputClick: openDateSentDatePicker, open: deliveryDateSentPickerOpen, onClickOutside: openDateSentDatePicker, onChange: (date) => onDesiredDeliveryDateChange(date), className: 'form-control vn-GeneralTab-Datepicker', dateFormat: 'dd-MM-yyyy', value: formatDMY(desiredDeliveryDate?.toString()) }), _jsxs("div", { className: 'input-group-append', children: [desiredDeliveryDate && (_jsx(IonIcon, { icon: close, className: 'vn-Datepicker-Icon datepicker-cancel-icon', onClick: clearDateSentHandleClick })), _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: openDateSentDatePicker })] })] })] }) }), _jsx("div", { className: 'col-sm-6', children: _jsxs(Form.Group, { children: [_jsx(Form.Label, { className: 'vn-text-label', children: "Leverdatum" }), _jsxs("div", { className: 'input-group', children: [_jsx(DatePicker, { selected: deliveryDate, className: 'form-control vn-Input vn-GeneralTab-Datepicker', placeholderText: 'Selecteer datum', onInputClick: openDeliveryDatePicker, open: deliveryDatePickerOpen, onClickOutside: openDeliveryDatePicker, onChange: (date) => onDeliveryDateChange(date), dateFormat: 'dd-MM-yyyy', value: formatDMY(deliveryDate?.toString()), disabled: !desiredDeliveryDate, minDate: desiredDeliveryDate }), _jsxs("div", { className: 'input-group-append', children: [deliveryDate && (_jsx(IonIcon, { icon: close, className: 'vn-Datepicker-Icon datepicker-cancel-icon', onClick: clearDeliveryDateHandleClick })), _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: openDeliveryDatePicker })] })] })] }) })] })] }) }), _jsx("div", { className: 'col-sm-3', children: id && (_jsx(_Fragment, { children: _jsx("div", { children: _jsx("div", { className: 'vn-quotation-info-tooltip-wrapper', children: _jsxs("div", { className: 'vn-quotation-info-icon-container', children: [_jsx(IonIcon, { onMouseEnter: handleMouseHover, onMouseLeave: handleMouseLeave, icon: informationCircleOutline, className: 'vn-QuotationInfoToolTip' }), isToolTipVisible && (_jsx("div", { className: 'vn-quotation-info-tooltip', children: _jsx(ToolTip, { content: _jsx(InfoToolTip, { formData: formData }) }) }))] }) }) }) })) })] }) }), _jsx(VnNotificationModel, { message: `Er zijn bestaande offertes:\n${quotationForSelectedWorkOrder && quotationForSelectedWorkOrder.length > 0 && quotationForSelectedWorkOrder
                    .map(q => q.quotationNumber.replace(/@@/g, ''))
                    .join('\n')}\nWeet u zeker dat u voor dezelfde werkorder aanvullende offertes wilt aanmaken?`, onCancel: () => onCancelQuotationWarningNotification(), onConfirm: () => onConfirmQuotationWarningNotification(), onOpen: isQuotationWarningMessagePopupOpen, onCancelShow: false })] }));
};
export default AddQuotationFormInTab;
